import { connect } from 'react-redux';
import MobileGoalsSummaryView from '../../MobileGoalsSummary/MobileGoalsSummaryView';
import * as selector from './GoalsSummarySelector';
import { currentClientIdSelector } from '../../CommonSelectors/CommonAreaSelector';

const mapStateToProps = state => ({
  goalsList: selector.goalsList(state),
  hasLoaded: selector.hasLoaded(state),

  clientId: currentClientIdSelector(state),
});

export const MobileGoalsSummary = connect(mapStateToProps)(MobileGoalsSummaryView);
